module.exports = __webpack_public_path__ + "img/about-section-3.4794aa7c.jpg";